export class OrganizationInviteCode {
    public static CODE_LENGTH = 10;
    id: number;
    code: string;
    accountId: string;
    uses: number;
    expiresAt: number;
    createdById: string;
}
